import styled from 'styled-components';
import { Button, Icon, Tooltip } from 'components/common';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

function Footer({
  crmId,
  crmType,
  onCancel,
  onExport,
  disabled,
  tooltip,
  loading,
}) {
  return (
    <Container>
      <Button size='middle' onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Tooltip title={!disabled ? tooltip : ''}>
        <Button
          size='middle'
          type='primary'
          onClick={onExport}
          disabled={disabled || loading || !crmId}
          icon={
            <Icon
              size='sm'
              icon='download'
              style={{ marginRight: '6px', color: 'currentColor' }}
            />
          }
        >
          Push to {crmType}
        </Button>
      </Tooltip>
    </Container>
  );
}

export default Footer;
